// import ActionCard from 'components/Common/ActionCard'
import NavigationCard from 'components/Common/NavigationCard'
// import useNavigateTo from 'hooks/useNavigateTo'
import { useEffect, useMemo } from 'react'
import { AppFC } from 'types'
import React from 'react'

import { RootState } from 'App'
import { connect, useSelector } from 'react-redux'
import { bindActionCreators } from 'redux'

import {
  ScrewdriverAndWrenchIcon,
  // GoTackleBrandIcon,
  LineChartIcon,
  ChatFilledIcon,
} from 'components/Common/SvgIcons'
import ArrowHitsTargetIcon from 'components/Common/SvgIcons/ArrowHitsTargetIcon'
import Card from 'components/Common/Card'
import { getStatistics } from 'store/selectors/playBook'
import { getAssessmentPlayListingAction } from 'store/actions/PlayBook'
import useGetChatCountLabel from 'hooks/useGetChatCountLabel'
import { useGetBoAdvisorsQuery } from '__generated__/api-types-and-hooks'
import { replaceTerm } from 'utils/helper'

export interface IOwnerNavigationCardProps {
  chatUnreadMessageCount: number
  topGoal: string
  stats: any
  getAssessmentPlayListingAction: (...args: any[]) => any
}

const OwnerNavigationCards: AppFC<IOwnerNavigationCardProps> = ({
  chatUnreadMessageCount,
  stats,
  topGoal,
  getAssessmentPlayListingAction,
}) => {
  const messageLabel = useGetChatCountLabel(chatUnreadMessageCount)
  // const navigateToChat = useNavigateTo('chat')

  useEffect(() => {
    getAssessmentPlayListingAction()
  }, [getAssessmentPlayListingAction])

  return (
    <div className="flex flex-col items-center gap-3 mt-[53px] max-w-[1250px] m-auto">
      <div className="grid grid-cols-3 gap-2 gap-y-4 sm:gap-4">
        <NavigationCard Icon={ChatFilledIcon} destination="chat" label={messageLabel} />
        {/* <NavigationCard Icon={GoTackleBrandIconWrapper} destination="playBooks" /> */}
        <NavigationCard Icon={ScrewdriverAndWrenchIconWrapper} destination="tools" />
        <NavigationCard Icon={LineChartIcon} destination="data" />
        {/* <TopGoalCard className="hidden lg:flex" topGoal={topGoal} /> */}
        <div className="col-span-3 grid grid-rows-2 md:grid-rows-none md:grid-cols-2 gap-4">
          <TopGoalCard topGoal={topGoal} />
          <BoAdvisorsCard />

          {/* <ActionCard onClick={navigateToChat}>
            <p className="font-semibold leading-4 text-base whitespace-nowrap">{messageLabel}</p>
          </ActionCard> */}
        </div>
      </div>
    </div>
  )
}

const BoAdvisorsCard: AppFC = ({ className }) => {
  type BoAdvisor = {
    firstName: string
    lastName: string
  }
  const { data } = useGetBoAdvisorsQuery()
  const bsoProfile = useSelector((state: RootState) => state.bso.bsoProfile)
  const term = 'advisor'
  const advisorTerm = replaceTerm(term, bsoProfile?.terminology)
  const advisorTermPlural = replaceTerm(term, bsoProfile?.terminology, { pluralized: true })

  const boAdvisors: BoAdvisor[] = useMemo(() => {
    const advisors = data?.getBoAdvisors?.data

    if (!advisors) return []
    return advisors.map((advisor) => ({
      firstName: advisor?.firstName || 'DefaultFirstName',
      lastName: advisor?.lastName || 'DefaultLastName',
    }))
  }, [data])
  return (
    <Card className={`flex-grow-1 ${className}`}>
      <div className="w-full h-full max-h-16 flex gap-4 sm:gap-5">
        <div className="flex flex-col gap-0.5">
          <p className="">{boAdvisors.length > 1 ? advisorTermPlural : advisorTerm}:</p>
          {boAdvisors.length > 0 ? (
            <div>
              {boAdvisors.slice(0, 2).map((advisor, index) => (
                <p key={index} className="font-bold leading-5">
                  {advisor?.firstName + ' ' + advisor?.lastName}
                </p>
              ))}
            </div>
          ) : (
            <p className="font-bold">No Advisor assigned</p>
          )}
        </div>
      </div>
    </Card>
  )
}

/** A small card displaying the the owner's top business goal */
const TopGoalCard: AppFC<{ topGoal: string }> = ({ topGoal = '', className }) => {
  return (
    <Card className={`flex-grow-1 ${className}`}>
      <div className="w-full h-full flex items-center justify-center gap-4 sm:gap-5">
        <div className="rounded-full h-[58px] w-[58px] min-h-[58px] flex-shrink-0 flex justify-center items-center">
          <ArrowHitsTargetIcon />
        </div>
        <div className="flex flex-col gap-0.5">
          <p className="">Your Top Business Goal:</p>
          <p className="font-bold leading-6">{topGoal}</p>
        </div>
      </div>
    </Card>
  )
}

const Minifier: AppFC = ({ children }) => (
  <div className="w-3/4 h-3/4 flex justify-center items-center">{children}</div>
)

// TO RETURN WHEN PLAYBOOKS RETURNS
// const GoTackleBrandIconWrapper: AppFC = () => (
//   <Minifier>
//     <GoTackleBrandIcon className="w-[43px] h-[35px] !w-2/3 fill-white" />
//   </Minifier>
// )

const ScrewdriverAndWrenchIconWrapper: AppFC = () => (
  <Minifier>
    <ScrewdriverAndWrenchIcon className="!w-1/2 fill-white" />
  </Minifier>
)

export default connect(
  (state: RootState) => {
    return {
      topGoal: state.user.businessProfile?.topGoal,
      stats: getStatistics(state),
    }
  },
  (dispatch) => {
    return bindActionCreators(
      {
        getAssessmentPlayListingAction: getAssessmentPlayListingAction.STARTED,
      },
      dispatch
    )
  }
)(OwnerNavigationCards)
